import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIProvince {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }


    async initInsert(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);

        return axios.post(this.getUrlDomain("TwoRecruitProvinceInitInsApiJM"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async insertProvincia(provincia, user) {

        let formData = new FormData();

        formData.append("username", user);

        for (var key in provincia) {
            formData.append(key, provincia[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitProvinceInsApiJM"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initEdit(id, user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitProvinceInitEditApiJM"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async updateProvincia(provincia, user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);

        for (var key in provincia) {
            formData.append(key, provincia[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitProvinceUpdApiJM"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteProvincia(user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);


        return axios.post(this.getUrlDomain("TwoRecruitProvinceDelApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initFilter(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("prodotto", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitProvinceInitFilterApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

  



}

export default new APIProvince({
    url: "https://services.ebadge.it/public/api/"
})
